import React, { useEffect, useState, useContext } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../services/timesheetreportsService';
import {timesheetuserService} from '../services/timesheetUserservice';
import {timesheetService} from '../services/timesheetService';
import {formatterhelper} from '../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {Nodatacomp,Nodataprimecomp} from '../compnents/nodatacomp';
import {loader} from '../compnents/loadermd';
import { MultiSelect } from 'primereact/multiselect';
import {dataExporthelper} from '../helpers/exporthelper';
import { InputText } from 'primereact/inputtext';
import {Statuscomp} from '../compnents/statuscomp';
import { useNavigate } from 'react-router-dom';
import { FaBeer, FaCheck, FaEdit, FaRecycle, FaSearch } from "react-icons/fa";
var XLSX = require("xlsx");
const FinalbillReports = () => {

    const [formData, setFormData] = useState({
        fromdate: '',
        manager_id: '',
        client: null,
        subclient: '',
        categories:'user',
        selectedteam:'ALL',
        dept:''
      });
    const [filtercomp,setfiltercomp] = useState(<></>);  
    const [datacomp,setDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [cleintlits,setClientlists] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [selecteddept, setSelectedDept] = useState(null);
    const [selectedclient, setSelectedClient] = useState(null);
    const [selectedcateg, setSelectedCateg] = useState('user');

    const [finalbillreportclient,setfinalbilldata] = useState([]);
    const [finalbillreportclienttemp,setfinalbilldatatemp] = useState([]);
    const [deptlists, setDepart] = useState([]);
    const [deptliststemp, setDeparttemp] = useState([]);
    const [userlists, setUsers] = useState([]);
    const [reportloaded,setloaderr] = useState(true);
    const [usermembers, setMemberscomp] = useState([]);
    const [errors, setErrors] = useState({});
    const [sumclientbilling,setbilling] = useState(0);
    const [qatotalhr_,setqatotalhr] = useState(0);
    const [totalbilledhours,setTotalBilledhours] = useState(0);
    const [totalFinalhours,setTotalFinalhours] = useState(0);
    const navigate = useNavigate();

    const cities = [
        { name: 'New York', code: 'NY' },
        { name: 'Rome', code: 'RM' },
        { name: 'London', code: 'LDN' },
        { name: 'Istanbul', code: 'IST' },
        { name: 'Paris', code: 'PRS' }
    ];

     
    useEffect(()=>{
        getemplist();
        // _getclientslist();
        getdepartments();
        getdepartmentstemp();
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
        
        if(name == 'categories'){
             setSelectedCateg(value);
        }

        if(name == 'manager_id'){
            _getclientslist(value);
        }

        if(name == 'dept'){
            console.log(value,'department');
            getdepartments(value);
            // _getclientslist(value);
        }
   };


   const validateForm = () => {
        let valid = true;
        const newErrors = {};

        if(formData.categories == 'client'){
            if (formData.fromdate == '') {
                newErrors.fromdate = 'Field is required';
                valid = false;
            }
    
            if (formData.manager_id == '') {
                newErrors.manager_id = 'Field is required';
                valid = false;
            }

            if (formData.client == '') {
                newErrors.client = 'Field is required';
                valid = false;
            }
            
            
        }else{
            if (formData.fromdate == '') {
                newErrors.fromdate = 'Field is required';
                valid = false;
            }
        }
        
        

        // if (formData.client == null) {
        //     newErrors.client = 'Field is required';
        //     valid = false;
        // }

        setErrors(newErrors);

      return valid; 
    }  

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm()){
            return;
        }
        if(formData.categories == 'client'){
            console.log('form data');
            let obj = {
                fromdate:formatterhelper.dateformatter({date:formData.fromdate}),
                manager_id:formData.manager_id,
                client:JSON.stringify(selectedclient),
                categories:formData.categories
            };
            // console.log(obj);
            finalbillreport({obj});
        }else if(formData.categories == 'user'){
           
           let obj = {
            fromdate:formatterhelper.dateformatter({date:formData.fromdate}),
            manager_id:formData.manager_id,
            client:JSON.stringify(selectedclient),
            selectedteam:formData.selectedteam,
            categories:formData.categories,
            dept:formData.dept
           };
           finalbillreport({obj});
        }
        // //console.log(reportobj);
        // setfilterobj(reportobj);
        // getreports({reportobj:reportobj});
        // Now you can perform any further actions with the form data
      };

    function formatToMonthYear(dateStr) {
        // 1. Check if value exists
        if (!dateStr || typeof dateStr !== "string") {
            return "";
        }

        // 2. Parse date
        const parsedDate = Date.parse(dateStr);

        // 3. Validate parsed date
        if (isNaN(parsedDate)) {
            return "";
        }

        const date = new Date(parsedDate);

        // 4. Format
        return date.toLocaleString("en-US", {
            month: "short",
            year: "numeric",
        });
    }
  


    function finalbillreport({obj}){
        setloaderr(false);
        if(obj.categories == 'client'){
            timesheetreportService.getfinalbillascategoriesmulti({obj}).then((response)=>{
                if(response.status == 200){
                    setfinalbilldata(response.data);
                    setfinalbilldatatemp(response.data);
                    setloaderr(true);
                    
                    
                    calculate(response.data,obj.categories);
                }else{
                    setfinalbilldata([]);
                    setfinalbilldatatemp([]);
                    setloaderr(true);
                    calculate([].categories);
                }
            }).catch((error)=>{
                // console.log(error);
                setfinalbilldata([]);
                setfinalbilldatatemp([]);
                setloaderr(true);
                calculate([].categories);
            });  
        }else{
            setloaderr(false);
            timesheetreportService.getfinalbillascategories({obj}).then((response)=>{
                if(response.status == 200){
                    setfinalbilldata(response.data);
                    setfinalbilldatatemp(response.data);
                    setloaderr(true);
                    calculate(response.data,obj.categories);
                }else{
                    setfinalbilldata([]);
                    setfinalbilldatatemp([]);
                    setloaderr(true);
                    calculate([].categories);
                }
            }).catch((error)=>{
                // console.log(error);
                setfinalbilldata([]);
                setfinalbilldatatemp([]);
                setloaderr(true);
                calculate([].categories);

            }); 
        }
    }  


    function calculate(resdata = [],type=''){
        let sum = 0; 
        var qasum = 0; 
        let totalbilledhours = 0;
        let totalFinalhours = 0;
        try{
            // console.log(resdata,'resdata');
            if(type == 'client'){
                
                resdata.forEach((value,index)=>{
                let clientbilldata  = (value.converted_timef < 0 || value.converted_timef == '' || value.converted_timef == null ? value.sumbilledhours : value.converted_timef);
                    if(clientbilldata != null){
                            sum = parseFloat(clientbilldata) + sum;
                    }

                    let qapercentval = '';
                    let qasum_ = value.qasum;
                    if(value.qapercent != '' && value.qapercent != undefined && !isNaN(value.qapercent)){

                        if(qasum_ != '' && qasum_ != undefined && qasum_ != null){
                            qapercentval = parseFloat((qasum_/60).toFixed(2));   
                        }else{
                            qapercentval = ((value.qapercent/100) * clientbilldata);      
                        }
                    }else
                    {
                        qapercentval = 0; 
                    }
                    qapercentval = parseFloat(qapercentval.toFixed(2));
                    qasum = qapercentval + qasum;
                    totalbilledhours += parseFloat(value.sumbilledhours) || 0;
                    totalFinalhours += parseFloat(value.converted_timef) || 0;
                });
                // console.log(typeof qasum,'qasum');
                sum = sum.toFixed(2);
                qasum = qasum;
                setTotalFinalhours(parseFloat(totalFinalhours.toFixed(2)));
                setqatotalhr(parseFloat(qasum.toFixed(2)));
                setbilling(sum);
                setTotalBilledhours(parseFloat(totalbilledhours.toFixed(2)));
            }else{
                resdata.forEach((value,index)=>{
                        let clientbilldata  = (value.final_valformat < 0 || value.final_valformat == '' || value.final_valformat == null ? value.billedhoursformat : value.final_valformat);
                        if(clientbilldata != null){
                                sum = parseFloat(clientbilldata) + sum;
                        }

                        let qapercentval = '';
                        let qasum_ = value.qasum;
                        if(value.qapercent != '' && value.qapercent != undefined && !isNaN(value.qapercent)){

                            if(qasum_ != '' && qasum_ != undefined && qasum_ != null){
                                qapercentval = parseFloat((qasum_/60).toFixed(2));   
                            }else{
                                qapercentval = ((value.qapercent/100) * clientbilldata);      
                            }
                        }else
                        {
                            qapercentval = 0; 
                        }
                        qapercentval = parseFloat(qapercentval.toFixed(2));  
                        console.log(qapercentval,'qapercentvalue');
                        qasum = qapercentval + qasum;  
                        totalbilledhours += parseFloat(value.billedhoursformat) || 0;
                        totalFinalhours += parseFloat(value.final_valformat) || 0;
                });
                sum = sum.toFixed(2);
                qasum = parseFloat(qasum.toFixed(2));
                setTotalFinalhours(totalFinalhours);
                setqatotalhr(qasum);
                setbilling(sum);
                setTotalBilledhours(totalbilledhours);
            }
            
        }catch(error){
            setbilling(sum);   
        }
    }


    const searchclients = (e) =>{
        // console.log(e.target.value);
        
        let value = e.target.value; 
        if(value.length <= 1){
            setfinalbilldata(finalbillreportclienttemp);
            calculate(finalbillreportclienttemp,formData.categories);
            return; 
        }
     //    datacomp
     //    datacomptemp 
        let _userdatalist = finalbillreportclienttemp;
        const searchRegexClient    = new RegExp(value.toLowerCase());
        const searchRegexSubclient = new RegExp(value.toLowerCase());
        const foundItems = _userdatalist.filter(item => 
        //   (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
         (searchRegexClient.test(item.client.toLowerCase()) || searchRegexSubclient.test(item.subclient.toLowerCase()))
        );
      
        if (foundItems.length > 0) {
            console.log('items found.');
            setfinalbilldata(foundItems);
            calculate(foundItems,formData.categories);
        } else {
            console.log('No items found.');
            setfinalbilldata([]);
        }
    }

    function getreports({reportobj,pageno}){
        let emparr = [];
        setloading(false);
        timesheetreportService.showreportgettimesheet({formdataobj:reportobj,pageno:pageno})
        .then((response)=>{
            // console.log('get reports');
            // console.log(response);

            if(response.status == 200){
                response.data.data.data.forEach((value,index) =>{
                    emparr.push((<tr>
                        <th>{value.ID}</th>
                        <td>{value.Date}</td>
                        <td>{value.User}</td>
                        <td>{value.client}</td>
                        <td>{value.subclient}</td>
                        <td>budget</td>
                        <td>{value.Task}</td>
                        <td>{value.user_role}</td>
                        <td>{value.user_roletype}</td>
                        <td>{value.BilledMinutes}</td>
                        <td>{value.Minutes}</td>
                        <td>{value.Count}</td>
                        <td>{value.Remarks}</td>
                        <td>{value.approved_date}</td>
                        <td>{value.timesheetfilleddt}</td>
                    </tr>));
                }); 
            
                let totalpage = response.data.data.total; 
                setPages(totalpage);
                setDatacomp(emparr);
                setDatastate(true);
                setloading(true);
            }else{
                setDatacomp([]);  
                setDatastate(false);
                setloading(true);
                setPages(0);
            }
        }).catch((error)=>{
            console.log(error);
            setDatacomp([]);  
            setDatastate(false);
            setloading(true);
            setPages(0);
        });
    }  

    function getemplist(){
        let member = userdata.id;
        let managerid = member;
        let emparr = [];
        // timesheetreportService.getmangrlist()
        timesheetreportService.getmangrlist().then((response)=>{
           console.log(response);
           response.data.data.forEach((value,index) =>{
              emparr.push((<option value={value.id}>{value.name}</option>));
           });
           setempcomp(emparr);
        }).catch((error)=>{

        });  
    }

    function _getclientslist(managerid){
        // let managerid = 1;
        let emparr = [];
        timesheetreportService.getclientslistmanager(managerid).then((response)=>{
            console.log(response);
            let tempclients = [];
         
            response.data.data.forEach((value,index) =>{
                emparr.push((<option value={value.client}>{value.client}</option>));
                if(value.client != ''){
                    tempclients.push(value);
                }
            });
            setClientlists(tempclients);
            setClientscomp(emparr);
         }).catch((error)=>{
 
         });    
    }

    function _getsubclient({clientid}){
        let _clientid = clientid;
        let emparr = [];
        timesheetService.getallsubclient({client:_clientid}).then((response)=>{
            console.log(response);
            response.data.data.forEach((value,index) =>{
                emparr.push((<option value={value.subclient}>{value.subclient}</option>));
            });
            setsubClientscomp(emparr);
         }).catch((error)=>{
 
         });   
    }

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        let pageno = 1;
        if(event.first == 0){
         pageno = 1;    
        }else{
         pageno = ((event.first/rows) + 1);  
        }
        // getUsers(pageno);
        getreports({reportobj:filterobj,pageno:pageno});
        // console.log(pageno);
    };

    const exportexcel = () =>{
       if(finalbillreportclient.length > 0){
           exportToExcel();     
       }
    }

    function exportToExcel() {
        let reportname = ''; 
        let id = '';
        if(selectedcateg == 'user'){
            reportname = 'finalbilluserreport';  
            id = 'user-data-table';
        }else{
            reportname = 'finalbillclientreport'; 
            id = 'client-data-table';  
        }
        dataExporthelper.exportFromhtml({id:id,reportname:reportname});
    }

   
    function filterComp(){
        let comp = (<></>);
        let categ = selectedcateg; 

        switch(categ){
            case 'client':
               comp = (<>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Month</label>
                        <Calendar  view="month" value={formData.fromdate} name="fromdate" onChange={handleChange} className='calender-custom-style' />
                        {errors.fromdate && <span className='error'>{errors.fromdate}</span>}
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Manager</label>
                        <select className='form-control' name="manager_id" onChange={handleChange}>
                            <option value=''>Select Manger</option>
                            <option value='all'>ALL</option>
                            {empcomp}
                        </select>
                        {errors.manager_id && <span className='error'>{errors.manager_id}</span>}
                    </div>
                    <div className="col-md-3">
                        <label className='pull-left'>Select Client</label>
                        <MultiSelect  name="client"  value={selectedclient} onChange={(e) => setSelectedClient(e.value)} options={cleintlits} optionLabel="client" filter
                         placeholder="Select Client" maxSelectedLabels={1} className="custom-element-style-multidropdown" />
                        {errors.client && <span className='error'>{errors.client}</span>}  
                    </div>
                 </>)  
                break;
            case 'user':
                comp = (<>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Month</label>
                        <Calendar  view="month" value={formData.fromdate} name="fromdate" onChange={handleChange} className='calender-custom-style' />
                        {errors.fromdate && <span className='error'>{errors.fromdate}</span>}
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Department</label>
                        {userdata.roletype == 'admin' ?(
                          <select className='form-control ' name="dept" value={selecteddept} onChange={handleChange} >
                            <option value='all'>ALL</option>
                            {deptliststemp}
                          </select>):( <MultiSelect value={selecteddept} onChange={(e) => setSelectedDept(e.value)} options={deptlists} optionLabel="dept" filter
                         placeholder="Select Department" maxSelectedLabels={3} className="w-full md:w-20rem custom-element-style-multidropdown" />)}
                       
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Member</label>
                        <select className='form-control ' name="selectedteam" value={formData.selectedteam} onChange={handleChange}>
                            <option value='ALL'>ALL</option>
                            {usermembers}
                        </select>
                    </div>
                 </>);
                break;
            default:

         } 
        return comp; 
        //  setfiltercomp(comp);   
    }

    function tabletypesdata({obj,type}){
        try{
            let comp = (<></>);
            switch(type){
            case 'client':
                let tempdata = [];
               
                obj.forEach((value,index)=>{

                    let clientbill = parseFloat(value.converted_timef < 0 || value.converted_timef == '' || value.converted_timef == null ? value.sumbilledhours : value.converted_timef) || 0;

                    let qapercentval = '';
                    console.log(value.isfullhr,value.subclient);
                    if(value.isfullhr == '1'){
                        qapercentval = parseFloat(((100/100) * clientbill).toFixed(2));
                        console.log(qapercentval,'qapercentval');
                    }else{
                        qapercentval = ((parseFloat(value.qapercent) || 0) / 100) * clientbill;
                        let qasum = value.qasum;
                        if(qasum != '' && qasum != undefined && qasum !== null){
                            qapercentval = parseFloat((qasum/60).toFixed(2));
                        }else{
                            qapercentval = parseFloat(qapercentval.toFixed(2));
                        }
                    }
                    if(isNaN(qapercentval)) qapercentval = '';

                    


                    tempdata.push(<tr>
                        <td scope="col">{index + 1}</td>
                        <td scope="col">{value.id}</td>
                        <td scope="col">{formatToMonthYear(value.dateformated)}</td>
                        <td scope="col">{value.empid}</td>
                        <td scope="col">{value.client}</td>
                        <td scope="col">{value.subclient}</td>
                        <td scope="col">{value.sumactualhours}</td>
                        <td scope="col">{value.sumbilledhours}</td>
                        <td scope="col">{value.converted_timef}</td>
                        <td scope="col">{value.services}</td>
                        <td>{value.converted_timef < 0 || value.converted_timef == '' || value.converted_timef == null ? value.sumbilledhours : value.converted_timef}</td>
                        <td scope="col">{value.qafullhrsum}</td>
                        <td scope='col'>{qapercentval}</td>
                        <td scope='col'>{value.qaaverage}</td>
                        {/* <td scope='col'><Statuscomp status={value.isenabled}/></td> */}
                    </tr>);
                });

                

                comp = (<table class="table table-bordered" id="client-data-table">
                <thead>
                    <tr>
                        <th scope="col">SR no</th> 
                        <th scope="col">Id</th>
                        <th scope="col">Month</th>
                        <th scope="col">Employee ID</th>
                        <th scope="col">Client</th>
                        <th scope="col">Sub Client</th>
                        <th scope="col">Actual Hours</th>
                        <th scope="col">Billing Hours</th>
                        <th scope="col">Final Billing Hours</th>
                        <th scope="col">Services</th>
                        <th scope="col">Client Billing</th>
                        <th scope="col">QAFullhr</th>
                        <th scope='col'>QA Hrs</th>
                        <th scope='col'>QA Avg</th>
                        {/* <th scope='col'>Isenabled</th> */}
                    </tr>
                </thead>
                <tbody>
                    {tempdata}  
                </tbody>
            </table>); 
            break;

            case 'user':
                let tempdata2 = [];
                obj.forEach((value,index)=>{

                    
                    let clientbill = parseFloat(value.final_valformat < 0 || value.final_valformat == '' || value.final_valformat == null ? value.billedhoursformat : value.final_valformat) || 0;

                    let qapercentval = value.qapercentval;

                    if(qapercentval != '' && qapercentval !== null && qapercentval != undefined){
                        console.log(typeof qapercentval);
                        console.log(qapercentval,'qa percentval',value.client,value.subclient);
                        qapercentval = parseFloat((qapercentval/60).toFixed(2));
                    }else{
                        qapercentval = ((parseFloat(value.qapercent) || 0) / 100) * clientbill;
                        qapercentval = parseFloat(qapercentval.toFixed(2));
                    }
                    if(isNaN(qapercentval)) qapercentval = '';
                    

                    tempdata2.push(<tr>
                        <td scope="col">{index+1}</td>
                        <td scope="col">{formatToMonthYear(value.dateformated)}</td>
                        <td scope="col">{value.empid}</td>
                        <td scope="col">{value.name}</td>
                        <td scope="col">{value.client}</td>
                        <td scope="col">{value.subclient}</td>
                        <td scope="col">{value.teamname}</td>
                        <td scope="col">{value.actualhourssum}</td>
                        <td scope="col">{value.billedhoursformat}</td>
                        <td scope="col">{value.final_valformat}</td>
                        <td scope="col">{value.services}</td>
                        <td>{value.final_valformat < 0 || value.final_valformat == '' || value.final_valformat == null ? value.billedhoursformat : value.final_valformat}</td>
                        <td scope="col">{value.lockedapproval}</td>
                        <td scope='col'>{value.qafullhr}</td>
                        <td scope='col'>{qapercentval}</td>
                        <td scope='col'>{value.qapercent}</td>
                    </tr>);
                });
                comp = (
                <table class="table table-bordered" id="user-data-table">
                <thead>
                    <tr>
                        <th scope="col">Id</th>
                        <th scope="col">Month</th>
                        <th scope="col">Employee ID</th>
                        <th scope="col">Username</th>
                        <th scope="col">Client Name</th>
                        <th scope="col">Sub Client Name</th>
                        <th scope="col">Team Name</th>
                        <th scope="col">Actual Hours</th>
                        <th scope="col">Billed Hours</th>
                        <th scope="col">Final Billing Hours</th>
                        <th scope="col">Difference</th>
                        <th scope="col">Client Billing</th>
                        <th scope="col">Islocked</th>
                        <th scope="col">QaFullhr</th>
                        <th scope="col">QA Hrs</th>
                        <th scope='col'>QA %</th>
                    </tr>
                </thead>
                <tbody>
                    {tempdata2}  
                </tbody>
            </table>); 
            break;


            default:
                comp = (<></>);
            }  
          return comp; 
        }catch(error){
            return (<></>);
        } 
    }

    function getdepartmentstemp(){
        timesheetuserService.getdepartments({userid:''}).then((response)=>{
            if(response.status == 200){
                let tempcomp2 = [];
                setDepart(response.data.dept);
                response.data.dept.forEach((value,index)=>{
                    tempcomp2.push((<option value={value.id}>{value.dept}</option>));      
                })
                setDeparttemp(tempcomp2);
             } 
        }).catch((error)=>{
            // console.log("error");
            // console.log(error);
        });
    }

    function getdepartments(userid = ''){
        timesheetuserService.getdepartments({userid:userid}).then((response)=>{
        //   console.log(response.data.dept); 
        //   console.log(response.data.users);
            if(response.status == 200){
                let tempcomp = [];
                let tempcomp2 = [];
                setDepart(response.data.dept);
                response.data.users.forEach((value,index)=>{
                    tempcomp.push((<option value={value.id}>{value.name}</option>));      
                }) 
                setMemberscomp(tempcomp);
            } 
        }).catch((error)=>{
            console.log("error");
            console.log(error);
        });
    }


   
    return (
        <>
            <div className="invisible-divider-sm"></div>
            <h6>Final Bill Reports</h6>
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                   <div className="col-md-2">
                        <label className='pull-left'>Categories</label>
                        <select className='form-control' name="categories" onChange={handleChange}>
                            <option value='user'>User</option>
                            <option value='client'>Client</option>
                        </select>
                    </div>
                    {filterComp({categ:'user'})}
                    <div className="col-md-2">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Show" severity="success" rounded className='custom-btn-style' />
                            &nbsp;&nbsp;&nbsp; 
                            <Button type='button' stype="button" label="Export" severity="info" rounded className='custom-btn-style' onClick={()=>exportexcel()} />
                        </div>
                        
                    </div>
                   
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'>
                       <span className="p-input-icon-left pull-left">
                        <FaSearch />
                        <InputText placeholder="Search" className="search-box-height"
                          onKeyDown={(e)=>{searchclients(e)}}
                        />
                        </span>
                   
                    </div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                        {isloaded && dataavail ? (<Paginator first={first} rows={rows} totalRecords={totalpages} rowsPerPageOptions={[15]} onPageChange={onPageChange} />) : (<></>)}
                        
                    </div>
                    
                </div>
               
                <div className='row'>
                    <div className='col-md-12'>
                        <br></br>
                        {!reportloaded ? <></> : !dataavail ?
                        (<>
                          <div className='sum-container-box'>
                              <div style={{display:'flex',justifyContent: 'space-between'}}>
                                 <div>
                                    <span className='text-danger'>* Please update the Final Bill data from the config so it reflects in Power BI. <span className='text-info' style={{cursor:'pointer'}} onClick={() => navigate('/finalbilling')}>
                                        Click here
                                        
                                        </span></span>
                                 </div>
                                 <div style={{display:'flex'}}>
                                    <div> 
                                    <span className='bold-txt'>Client Billing Sum : </span>
                                    <span>{sumclientbilling}</span>
                                        </div>
                                        &nbsp;
                                        &nbsp;
                                        |

                                        &nbsp;
                                        &nbsp;

                                        <div style={{color:'red'}}> 
                                            <span className='bold-txt'>  QA Hours Sum : </span>
                                            <span>{qatotalhr_}</span>
                                        </div>

                                 </div>
                              </div>
                          </div>
                          <br/>
                          <span>Total Billed hours : {totalbilledhours}</span> || &nbsp;
                          <span>Total Final hours : {totalFinalhours}</span>
                        </>) : <></>}
                        <br/>
                        <br/>
                       {!reportloaded ? loader.Loadermd() : !dataavail ?
                       
                       (
                        tabletypesdata({obj:finalbillreportclient,type:formData.categories})) : (<Nodataprimecomp/>)} 
                    </div>
                </div>
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default FinalbillReports;